module.exports = __webpack_public_path__ + "img/home_img_1_nor@2x.102e819f.png";